// @ts-nocheck
import React from 'react';
import moment from 'moment';
import { Table } from '../../../components/ant/table/Table';
import Header from '../../../components/layout/Header';
import { Section } from '../../../components/layout';
import Filter from './components/Filter';
import { fuelTypes, fuelTypeEnum } from '../../../lib/enum';
const initialParams = {
  startDate: moment.utc().startOf('month').toISOString(),
  endDate: moment.utc().endOf('month').toISOString()
};
/**
 * Реестр путевых листов по автотранспортным услугам
 */
export class TripsRegistryList extends React.Component {
  state = {
    params: initialParams
  };
  handleChangeFilter = (key, value) => {
    this.setState(prevState => ({
      params: {
        ...prevState.params,
        [key]: value
      }
    }));
  };
  applyParams = async () => {};
  cleanParams = () => this.setState({
    params: initialParams
  });
  handleExport = async () => {};
  mock = [{
    orgUnitName: 'Главный',
    tripDate: '15.12.2018',
    date: '20.12.2018',
    type: 'car',
    brandName: 'Nissan',
    licensePlate: 'Т865ХМ 716',
    kilometrage: 166,
    kilometrageDeviation: 0.15,
    tripNumber: 1,
    fuel: 23,
    fuelDeviation: 0.25,
    primaryFuelType: fuelTypeEnum.ai92,
    totalWorkTime: 12,
    movedTime: 120
  }, {
    orgUnitName: 'Главный',
    tripDate: '18.12.2018',
    date: '20.12.2018',
    type: 'car',
    brandName: 'Лада',
    licensePlate: 'К325ЛМ 16',
    kilometrage: 25500,
    tripNumber: 2,
    kilometrageDeviation: 0.1,
    fuel: 56,
    fuelDeviation: 0.15,
    primaryFuelType: fuelTypeEnum.ai92,
    totalWorkTime: 10,
    movedTime: 155
  }, {
    orgUnitName: 'Главный',
    tripDate: '20.12.2018',
    date: '20.12.2018',
    type: 'car',
    brandName: 'Reno',
    licensePlate: 'М124КВ 116',
    kilometrage: 673133,
    tripNumber: 3,
    kilometrageDeviation: 0.56,
    fuel: 30,
    fuelDeviation: 0.25,
    primaryFuelType: fuelTypeEnum.ai92,
    totalWorkTime: 56,
    movedTime: 135
  }];
  columns = [{
    title: 'Филиал',
    dataIndex: 'orgUnitName'
  }, {
    title: 'Дата формирования',
    dataIndex: 'date'
  }, {
    title: '№ путевого листа',
    dataIndex: 'tripNumber'
  }, {
    title: 'Дата путевого листа',
    dataIndex: 'tripDate'
  }, {
    title: 'Гос. номер',
    dataIndex: 'licensePlate'
  }, {
    title: 'Вид топлива',
    dataIndex: 'primaryFuelType',
    render: value => fuelTypes[value]
  }, {
    title: 'Время работы всего',
    dataIndex: 'totalWorkTime',
    render: value => `${value} ч.`
  }, {
    title: 'Время в движении',
    dataIndex: 'movedTime',
    render: workTime => `${workTime} ч.`
  }];
  render() {
    return <>
        <Header left={<h1>Реестр путевых листов по автотранспортным услугам</h1>} />
        <Section>
          <Filter params={this.state.params} onChangeFilter={this.handleChangeFilter} applyParams={this.applyParams} cleanParams={this.cleanParams} onExport={this.handleExport} />
          <Table pagination={false} dataSource={this.mock} columns={this.columns} />
        </Section>
      </>;
  }
}
export default TripsRegistryList;
